import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';

import Wizard from './Wizard/Wizard';
import { SelfServeStepsIdentifiers } from './constants';
import ProductListForm from './forms/ProductListForm';
import BusinessInformation from './stepsContent/BusinessInformation';
import ServicePricing from './stepsContent/ServicePricing';
import { SelfServeStepsType, SelfServeWizardStep } from './types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  width: 480px;
  margin-block: 32px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: auto;
    padding-inline: 16px;
    margin-block: 24px;
  }
`;

const isSelfServeStep = (stepParam: string): boolean =>
  Object.values(SelfServeStepsIdentifiers).includes(stepParam as SelfServeStepsType);

const validateStepParam = (param: string | null) => {
  if (!param) {
    return SelfServeStepsIdentifiers.VenueDetails;
  }

  const isValidParam = isSelfServeStep(param);

  return isValidParam ? param.toLowerCase() : SelfServeStepsIdentifiers.VenueDetails;
};

const SelfServeSignupWizard = () => {
  const location = useLocation();
  const [stepParam, setStepParam] = useState<string>(SelfServeStepsIdentifiers.VenueDetails);

  const wizardData: SelfServeWizardStep[] = [
    {
      title: 'Complete your business information',
      identifier: SelfServeStepsIdentifiers.VenueDetails,
      component: BusinessInformation,
    },
    {
      title: 'Your products',
      identifier: SelfServeStepsIdentifiers.ProductList,
      component: ProductListForm,
    },
    {
      title: 'Service plan',
      identifier: SelfServeStepsIdentifiers.ServicePricing,
      component: ServicePricing,
    },
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const newStepParam = validateStepParam(searchParams.get('step'));
    setStepParam(newStepParam);
  }, [location.search]);

  return (
    <Wrapper>
      <Wizard wizardData={wizardData} currentStepIdentifier={stepParam} />
    </Wrapper>
  );
};

export default SelfServeSignupWizard;
